// Service-worker registration + a small "new version ready" toast. We use
// registerType: "prompt", so a SW update never swaps code mid-feed-log — the
// caretaker taps Reload when it suits them.

import { useRegisterSW } from "virtual:pwa-register/react";
import { useT } from "../lib/LocaleContext";

export function UpdatePrompt() {
  const t = useT();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div style={styles.toast} role="status">
      <span style={styles.text}>{t.pwa.updateReady}</span>
      <button style={styles.later} onClick={() => setNeedRefresh(false)}>
        {t.pwa.later}
      </button>
      <button style={styles.reload} onClick={() => updateServiceWorker(true)}>
        {t.pwa.reload}
      </button>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  toast: {
    position: "fixed",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: "max(16px, env(safe-area-inset-bottom))",
    zIndex: 200,
    display: "flex",
    alignItems: "center",
    gap: 10,
    maxWidth: "calc(100vw - 24px)",
    background: "var(--bh-surface)",
    border: "1px solid var(--bh-divider)",
    borderRadius: 16,
    padding: "10px 12px 10px 16px",
    boxShadow: "0 12px 32px oklch(0 0 0 / 0.4)",
  },
  text: { fontSize: 14, color: "var(--bh-ink-2)" },
  later: {
    background: "transparent",
    border: "none",
    color: "var(--bh-ink-3)",
    fontSize: 14,
    fontFamily: "inherit",
    padding: "8px 6px",
    cursor: "pointer",
  },
  reload: {
    background: "var(--bh-feed)",
    color: "oklch(0.2 0.04 70)",
    border: "none",
    borderRadius: 10,
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "inherit",
    padding: "8px 14px",
    cursor: "pointer",
  },
};
